( function ($) {
    $(document).on('ready', function () {
        doMinigallery();
    });

    function lazySlide(array, index) {
        var sources = $(array[index]).find('source');
        var img = $(array[index]).find('img');
        var src = img.attr('data-src');

        sources.each(function () {
            var source = $(this).attr('data-srcset');
            $(this).attr('srcset', source);
            $(this).attr('data-processed', 'true');
            $(this).removeAttr('data-srcset');

        });
        img.attr('src', src);
        img.attr('data-processed', 'true');
        img.removeAttr('data-src');
    }

    function doMinigallery() {
        var wrap = $('.minigallery');
        if (wrap.length > 0) {
            //LAZY LOADING (before carousel is loaded)
            wrap.on("init", function () {

                //load 1st, 2nd and last slide
                var slides = wrap.find('.slide');
                if (slides.length <= 1) {
                    dots = false
                }
                var slidesLoaded = [slides[0], slides[1], slides[wrap.length - 1]];

                //items index change based on animation kind (0 to n-1 for fade, 1 to n for slide)
                slides.each(function (index) {
                    lazySlide(slidesLoaded, index);
                })
            });

            //slideshow setup
            wrap.slick({
                rows: 0,
                fade: false,
                arrows: true,
                dots: false,
                infinite: true,
                nextArrow: wrap.parent().find('.next'),
                prevArrow: wrap.parent().find('.prev'),
            });


            //LAZY LOADING (after carousel is loaded)

            //load 1st, 2nd and last clone
            var clones = wrap.find('.slick-cloned');
            var clonesLoaded = [clones[0], clones[1], clones[wrap.length - 1]];

            //items index change based on animation kind (0 to n-1 for fade, -1 to n-2 for slide)
            clones.each(function (index) {
                lazySlide(clonesLoaded, index);
            });

            wrap.on("afterChange", function (e, slick) {
                var slides = $.merge(slick.$slides, clones);

                //load next slide + 1
                var index = slick.currentSlide + 1;

                lazySlide(slides, index);

                //load previous slide - 1
                if (slick.currentSlide === 0) {
                    index = wrap.length - 1;
                } else {
                    index = slick.currentSlide - 1;
                }
                lazySlide(slides, index);

                //load current slide if click on pager
                var indexCurrent = slick.currentSlide;

                lazySlide(slides, indexCurrent);
            });
        }
    }


}(jQuery) );